import { findSwipersInBlocks } from '../parts/ui';

jQuery(document).ready(function () {
    const block = $('.guarantees-block');
    if (!block.get(0)) return;
    findSwipersInBlocks('.guarantees-block', {
        spaceBetween: 20,
        breakpoints: {
            1: {
                spaceBetween: 16,
                slidesPerView: 'auto',
                direction: 'vertical'
            },

            577: {
                slidesPerView: 'auto',
                direction: 'horizontal'
            },
            1281: {
                slidesPerView: 3
            }
        }
    });
});
